var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header__profile profile"},[(_vm.user.authenticated)?_c('div',{staticClass:"profile__dropdown"},[_c('RoleSelect')],1):_vm._e(),_vm._v(" "),(_vm.user.authenticated)?_c('a',{staticClass:"logout-btn link link--blue",attrs:{"href":""},on:{"click":function($event){_vm.logout()}}},[_c('span',[_vm._v(_vm._s(_vm.$t('header.logout'))+" ")]),_c('i',{staticClass:"fa fa-sign-out"}),_c('i',{staticClass:"icon icon--arrow"})]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a922f5de","hasScoped":true,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/ProfileHeader.vue
// module id = 1516
// module chunks = 65